import { Panel, PanelType, PrimaryButton, DefaultButton } from '../../fluent';
import { CodeEditor } from './CodeEditor';
import React from 'react';
export const XmlEditorPanel = (props) => {
    return React.createElement(Panel, { isOpen: props.show, type: PanelType.large, headerText: props.title, hasCloseButton: false, isFooterAtBottom: true, onRenderFooterContent: () => React.createElement("div", null,
            React.createElement("div", { className: 'ms-Grid-row' },
                React.createElement("div", { className: 'ms-Grid-col ms-u-sm12', style: { textAlign: 'right' } },
                    React.createElement(PrimaryButton, { text: 'Aceptar', primary: true, onClick: () => {
                            let newProps = undefined;
                            try {
                                newProps = JSON.parse(props.code);
                            }
                            catch (error) {
                                if (props.onValidationError) {
                                    props.onValidationError();
                                }
                                return;
                            }
                            props.onAccept(JSON.stringify(newProps, undefined, 2));
                            props.onClose();
                        } }),
                    React.createElement("span", null, "\u00A0\u00A0"),
                    React.createElement(DefaultButton, { text: 'Volver', primary: false, onClick: () => props.onClose() })))), closeButtonAriaLabel: 'Cerrar' },
        React.createElement(CodeEditor, { value: props.code || '', onChanged: value => props.onChange(value), language: 'xml' }));
};
